define('views/shared/panel/transfer',[
    'backbone',
    'views/shared/panel/panel',
    'text!views/shared/panel/transfer.html'
], function(Backbone, PanelView, Template){
    'use strict';

    return PanelView.extend({
        id      : 'transfer-inner-container',
        tagName : 'div',
        isRender: true,
        template: _.template(Template),
        events  : {},
        initialize: function(options){
            options = options || {};

            this.is_open = false;
            this.panel_type = 2;
            this.elementName = options.elementName;

            PanelView.prototype.initialize(this);
        },

        render: function(){

            this.$el.html(this.template());
            return this;
        },
		loadData: function () {
			setTimeout(function () {
				$.ajax({
					contentType: "application/json",
					// url: "https://devapi.payforward.com/Transfers/Rules/",
					url: "https://devapi.payforward.com/Users/f8543e66097a45d4baafaeaaeb729fe4/Transfers/Suggestions", 
					type: 'GET',
					success: function (response) {
						console.log("success", response);
					},
					error: function (response) {
						console.log("error", response);
					}
				})
			}, 3000);
		},
		afterRender: function () {
			// test output from transfer end point
			// $.ajax({
// 				url: "https://devapi.payforward.com/Transfers/Rules/",
// 				// url: "https://devapi.payforward.com/Users/f8543e66097a45d4baafaeaaeb729fe4/Transfers/Suggestions",
// 			}).done(function (response) {
// 				console.log('done', response);
// 			}).fail(function (error) {
// 				console.log('error', error.statusText, error);
// 			});
			
			
			
			
			//f8543e66097a45d4baafaeaaeb729fe4
		},

        close: function(){}
    });
});

